module.exports = __webpack_public_path__ + "img/bg20.29a584ef.jpeg";